export default __webpack_public_path__ + "static/media/hero_caracal_two.208dac4c.jpeg";